//import { JoyIDWallet } from "../client/JoyIDWallet";
import { StarknetWindowObject } from "get-starknet";
import { Wallet } from "../client/Wallet";

export class ViewData {
    static wallet: Wallet | null;
    static ethAddress: string = "";
    static ckbAddress: string = "";
    static loggedWithJoyID: boolean = false;
    static isEvmDeployer: boolean = false;

    static starknetAddress: string = "";

    static did: string = "";
    // static didENS: string = "";
    // static didDotBit: string = "";

    static ckbBalance: number = 20000;
    static latitude: number = 0;
    static longitude: number = 0;
    
    static sampleHex: string = "";
    static hex64: string = "";
    static pubKeyHex_Nervos: string = "";

    static MintStatus = {
        ethereum: false,
        arbNova: false,
        base: false,
        godwoken: false,
        linea:false,
        opBnb: false,
        pgn: false,
        polygonZkEvm: false,
        scroll: false,
        taiko: false,
        zksync: false,
        zora: false,

        nervos: false,
        starknet: false,
    }
}